import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class ENEuropee extends Component {
  render() {
    let { nazione} = this.props.params;
    let repoFascione = "/elezioni/withub/electionday-2024/europee/fascione-europa.html";
    let repoDettaglio = "/elezioni/withub/electionday-2024/europee/nazioni_es/dettaglio-" + nazione + ".html";
    return (
    <div className="App">
        <EWH id="ewh-fascione" repo={repoFascione} />
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
    </div>
    )
  }
}

export default withParams(ENEuropee)
